import * as tslib from 'tslib'
import { initFederation } from '@angular-architects/native-federation-v4'
import { loadRuntimeConfig } from './app/config/runtime-config'

// Polyfill global require para esbuild cuando necesita resolver 'tslib'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
;(window as any).require = (id: string) => {
  if (id === 'tslib') {
    return tslib
  }
  throw new Error(`Dynamic require of "${id}" is not supported`)
}

/**
 * Carga la configuración del dominio antes de iniciar el Shell.
 * El orden importa: initFederation() instala el import map que
 * loadRuntimeConfig() necesita para resolver la lib shared.
 */
initFederation()
  .then(() => loadRuntimeConfig().catch(() => undefined))
  .then(() => import('./bootstrap'))
  .catch((err) => console.error(err))
